/**
 * @module enum
 */
export enum GetGroupMessageReadMemberListFilter {
    /**
     * 禁止加群
     */
    V2TIM_GROUP_MESSAGE_READ_MEMBERS_FILTER_READ,

    /**
     * 需要管理员审批
     */
    V2TIM_GROUP_MESSAGE_READ_MEMBERS_FILTER_UNREAD,
}
